module.exports = __webpack_public_path__ + "img/occidental-hotel-1.2471a40e.jpg";